// import { Phone, Mail } from "lucide-react";

// const ContactUs = () => {
//   return (
//     <div className="min-h-[calc(100vh-4rem)] px-6 py-8">
//       <div className="max-w-5xl mx-auto">

//         {/* HEADER */}
//         <div className="mb-10">
//           <h1 className="text-3xl font-semibold text-slate-800">
//             Contact Us
//           </h1>
//           <p className="mt-2 text-slate-500">
//             We’re here to help you with anything you need
//           </p>
//         </div>

//         {/* 3D CARD */}
//         <div
//           className="
//             relative rounded-[32px] p-8
//             bg-gradient-to-br from-[#FDECEC] via-[#FFF3F1] to-[#EEF2FF]
//             shadow-[20px_20px_50px_rgba(190,60,50,0.25),-20px_-20px_50px_rgba(255,255,255,0.9)]
//           "
//         >
//           {/* INNER NEUMORPHIC LAYER */}
//           <div
//             className="
//               absolute inset-[6px] rounded-[26px]
//               bg-gradient-to-br from-[#FFF5F4] to-[#F8FAFF]
//               shadow-[inset_8px_8px_16px_rgba(190,60,50,0.18),inset_-8px_-8px_16px_rgba(255,255,255,0.9)]
//               pointer-events-none
//             "
//           />

//           {/* CONTENT */}
//           <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 justify-center">

//             {/* PHONE */}
//             <div
//               className="
//                 rounded-2xl p-6
//                 bg-white/70
//                 shadow-[8px_8px_18px_rgba(0,0,0,0.15),-8px_-8px_18px_rgba(255,255,255,0.9)]
//                 hover:-translate-y-1 hover:shadow-xl transition
//               "
//             >
//               <div
//                 className="
//                   w-12 h-12 rounded-xl mb-4
//                   bg-gradient-to-br from-rose-500 to-pink-400
//                   text-white flex items-center justify-center shadow-lg
//                 "
//               >
//                 <Phone />
//               </div>
//               <p className="text-sm text-slate-500">Phone</p>
//               <p className="mt-1 font-semibold text-slate-800">
//                 +91 8586036036
//               </p>
//             </div>

//             {/* EMAIL */}
//             <div
//               className="
//                 rounded-2xl p-6
//                 bg-white/70
//                 shadow-[8px_8px_18px_rgba(0,0,0,0.15),-8px_-8px_18px_rgba(255,255,255,0.9)]
//                 hover:-translate-y-1 hover:shadow-xl transition
//               "
//             >
//               <div
//                 className="
//                   w-12 h-12 rounded-xl mb-4
//                   bg-gradient-to-br from-indigo-500 to-cyan-500
//                   text-white flex items-center justify-center shadow-lg
//                 "
//               >
//                 <Mail />
//               </div>
//               <p className="text-sm text-slate-500">Email</p>
//               <p className="mt-1 font-semibold text-slate-800">
//                 care@bingopays.in 
//               </p>
//             </div>
//           </div>

//           {/* FOOTER NOTE */}
//           <div className="mt-10 text-center">
//             <span
//               className="
//                 inline-block px-6 py-3 rounded-full
//                 bg-gradient-to-r from-rose-500 to-pink-400
//                 text-white font-semibold text-sm
//                 shadow-[0_10px_30px_rgba(225,29,72,0.35)]
//               "
//             >
//               Support available 10:00 AM – 6:00 PM
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;



// new ui 

import React from "react";
import { 
  Phone, 
  Mail, 
  Clock, 
  Headphones, 
  ArrowUpRight, 
  Sparkles, 
  MessageSquare,
  ShieldCheck
} from "lucide-react";

const ContactUs = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#F8FAFC] px-4 py-8 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="w-full max-w-4xl mx-auto space-y-8">
        
        {/* ================= HERO HEADER ================= */}
        <div className="text-center space-y-2">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-600 border border-blue-100/80 mb-1">
            <Headphones className="w-3.5 h-3.5" />
            Dedicated Helpdesk
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-800">
            We’re Here to Help You
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 max-w-md mx-auto">
            Have questions regarding settlements, terminal transactions, or onboarding? Reach out to our support team.
          </p>
        </div>

        {/* ================= MAIN CONTACT CONTAINER ================= */}
        <div className="relative overflow-hidden rounded-3xl bg-white border border-slate-200/80 p-6 sm:p-10 shadow-xs">
          
          {/* Ambient background glow accents */}
          <div className="absolute -top-24 -right-24 w-72 h-72 bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-indigo-500/5 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 space-y-8">
            
            {/* Contact Method Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              
              {/* PHONE CARD */}
              <a
                href="tel:+918586036036"
                className="group p-6 rounded-2xl bg-slate-50/70 hover:bg-white border border-slate-200/70 hover:border-blue-200 hover:shadow-lg hover:shadow-blue-900/5 transition-all duration-200 flex flex-col justify-between"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-tr from-blue-600 to-indigo-600 text-white flex items-center justify-center shadow-md shadow-blue-500/20 group-hover:scale-105 transition-transform">
                    <Phone className="w-5 h-5" />
                  </div>
                  <span className="p-2 rounded-xl text-slate-400 group-hover:text-blue-600 group-hover:bg-blue-50 transition-colors">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>

                <div className="mt-6 space-y-1">
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Direct Helpline
                  </p>
                  <p className="text-lg font-bold text-slate-800 tracking-tight group-hover:text-blue-600 transition-colors">
                    +91 8586036036
                  </p>
                  <p className="text-[11px] text-slate-500 font-medium">
                    Call for instant assistance on urgent queries
                  </p>
                </div>
              </a>

              {/* EMAIL CARD */}
              <a
                href="mailto:care@bingopays.in"
                className="group p-6 rounded-2xl bg-slate-50/70 hover:bg-white border border-slate-200/70 hover:border-indigo-200 hover:shadow-lg hover:shadow-indigo-900/5 transition-all duration-200 flex flex-col justify-between"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-tr from-indigo-600 to-sky-500 text-white flex items-center justify-center shadow-md shadow-indigo-500/20 group-hover:scale-105 transition-transform">
                    <Mail className="w-5 h-5" />
                  </div>
                  <span className="p-2 rounded-xl text-slate-400 group-hover:text-indigo-600 group-hover:bg-indigo-50 transition-colors">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>

                <div className="mt-6 space-y-1">
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Official Email
                  </p>
                  <p className="text-lg font-bold text-slate-800 tracking-tight group-hover:text-indigo-600 transition-colors">
                    care@bingopays.in
                  </p>
                  <p className="text-[11px] text-slate-500 font-medium">
                    Send detailed tickets, dispute logs, or reports
                  </p>
                </div>
              </a>
            </div>

            {/* Operating Hours & Guarantee Banner */}
            <div className="p-4 sm:p-5 rounded-2xl bg-gradient-to-r from-slate-900 via-[#0F2942] to-slate-900 text-white flex flex-col sm:flex-row items-center justify-between gap-4 shadow-sm">
              <div className="flex items-center gap-3 text-center sm:text-left">
                <div className="p-2 rounded-xl bg-white/10 text-amber-300">
                  <Clock className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-xs font-bold text-white">Working Hours</p>
                  <p className="text-[11px] text-slate-300">Monday to Saturday • 10:00 AM – 6:00 PM</p>
                </div>
              </div>

              <div className="flex items-center gap-2 text-xs font-semibold text-emerald-300 bg-emerald-500/10 border border-emerald-400/20 px-3 py-1.5 rounded-full">
                <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" />
                Verified Merchant Support
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactUs;